import { queryOptions, useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const feedSettingsQueryOptions = queryOptions({
  queryKey: ['feed-settings'],
  queryFn: async () => {
    const { data, error } = await supabase
      .from('feed_settings')
      .select('promoted_cards_ignore_filters, assistant_hero_title, assistant_hero_subtitle, assistant_hero_description, assistant_hero_button_text, assistant_tooltip_text, feed_type, currency, feed_parser_version, assistant_translations, assistant_steps, assistant_results, assistant_labels, assistant_badges, assistant_reasons, assistant_tooltips, sponsored_cards_translations')
      .maybeSingle();

    if (error) throw error;
    return data;
  },
  staleTime: 30 * 60 * 1000, // 30 minutes - settings rarely change
  gcTime: 60 * 60 * 1000, // 1 hour in cache
});

export const useFeedSettings = () => useQuery(feedSettingsQueryOptions);
